import React from 'react';
import style from './style.module.scss';
import { PrimaryButton } from '@magoosh/lib/button';
import { paths } from 'config/path_helpers';
import CancelOption from './cancel_option';

export default () => (
  <div className={style.greenBorder}>
    <div className={style.top}>
      <h3 className={style.planHeader}>
        <strong>It's time for</strong> your practice test!
      </h3>
      <CancelOption />
    </div>
    <p>
      <PrimaryButton href={paths.startPracticeTest}>Start Practice Test</PrimaryButton>
    </p>
  </div>
);
